'use client';

import { c as _c } from "react/compiler-runtime";
import { Dispatch, ReactNode, SetStateAction, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Consent } from '@personly/libs-widgets';
import type { CookieType } from '@personly/libs-types';
import { useCookies } from '@personly/libs-providers';
const toTypeHandles = (cookieTypes: CookieType[]) => cookieTypes.map(({
  handle
}) => handle);
type Context = {
  consentSettingsOpen: boolean;
  setConsentSettingsOpen: Dispatch<SetStateAction<boolean>>;
  selectedCookieType: CookieType;
  setSelectedCookieType: Dispatch<SetStateAction<CookieType>>;
  selectedCookieTypes: string[];
  setSelectedCookieTypes: Dispatch<SetStateAction<string[]>>;
};
const ConsentsContext = createContext<Context | null>(null);
interface Props {
  children: ReactNode;
  cookieTypes: CookieType[];
  consentLabel: string;
}
const ConsentsProvider = t0 => {
  const $ = _c(15);
  const {
    children,
    cookieTypes,
    consentLabel
  } = t0;
  const {
    consent
  } = useCookies();
  const [openAfterLightHouse, setOpenAfterLighthouse] = useState(false);
  const [consentSettingsOpen, setConsentSettingsOpen] = useState(false);
  const [selectedCookieType, setSelectedCookieType] = useState(cookieTypes[0]);
  let t1;
  if ($[0] !== cookieTypes) {
    t1 = toTypeHandles(cookieTypes);
    $[0] = cookieTypes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedCookieTypes, setSelectedCookieTypes] = useState(t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setTimeout(() => setOpenAfterLighthouse(true), 3000);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const isOpen = consent.createdAt === 0 && openAfterLightHouse;
  let t4;
  if ($[4] !== consentSettingsOpen || $[5] !== selectedCookieType || $[6] !== selectedCookieTypes) {
    t4 = {
      consentSettingsOpen,
      setConsentSettingsOpen,
      selectedCookieType,
      setSelectedCookieType,
      selectedCookieTypes,
      setSelectedCookieTypes
    };
    $[4] = consentSettingsOpen;
    $[5] = selectedCookieType;
    $[6] = selectedCookieTypes;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const value = t4;
  let t5;
  if ($[8] !== children || $[9] !== consentLabel || $[10] !== isOpen) {
    t5 = <Consent isOpen={isOpen} consentLabel={consentLabel}>{children}</Consent>;
    $[8] = children;
    $[9] = consentLabel;
    $[10] = isOpen;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5 || $[13] !== value) {
    t6 = <ConsentsContext.Provider value={value}>{t5}</ConsentsContext.Provider>;
    $[12] = t5;
    $[13] = value;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function useConsents() {
  const context = useContext(ConsentsContext);
  if (!context) {
    throw new Error("useConsents requires a context!");
  }
  return context;
}
export { ConsentsProvider, useConsents };